import React, { useState } from 'react';
import './css/Card.css';
import CardImg from '../5.png';
import aurumImg from '../6.png';
import sonatImg from '../7.png';
import mwrImg from '../mwr.png';
import { Turl } from './tUrl.js'
import { t } from 'ttag';
import { mixpanel } from './mp.js';


const tg = window.Telegram ? window.Telegram.WebApp : null;

function Card({ amount, adr, handlesetIndex }) {
    const [isFetchingAurum, setIsFetchingAurum] = useState(false);

    const handleAurumClick = async () => {
        if (isFetchingAurum) return;
        setIsFetchingAurum(true);
        try {
            const _userData = tg ? tg.initData : null;
            let userData = { initData: _userData }
            const response = await fetch(Turl + '/api/aurumLink', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(userData)
            });
            const data = await response.json();
            if (data && data.url) {
                window.open(data.url, '_blank', 'noopener,noreferrer');
            } else if (typeof data === 'string' && data.startsWith('http')) {
                // В случае если API возвращает строку с URL
                window.open(data, '_blank', 'noopener,noreferrer');
            } else {
                console.error("Не удалось получить ссылку Aurum:", data);
            }
        } catch (error) {
            console.error("Ошибка при получении ссылки Aurum:", error);
        } finally {
            setIsFetchingAurum(false);
        }
    };
    const btn = amount >= 1000 ?
        <a href={adr} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', border: 'none' }}>
            <button className="get-card-button" style={{ marginTop: 0, padding: '10px 20px', fontSize: '1.2em' }}>
                Перейти
            </button>
        </a>
        :
        <button className="get-card-button" style={{ marginTop: 0, padding: '10px 20px', fontSize: '1.2em' }}>
            Перейти
        </button>
    return (
        <div className="crypto-card-block">
            <div className="card-hader">
                <div className="card-hader-h1">
                    Партнеры
                </div>
            </div>

            <div className="partners-list" style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
                <div className="axiom-block partner-item" style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <img src={CardImg} alt="" style={{ width: '80px' }} />
                        <div className="card-hader-h2" style={{ margin: 0 }}>Крипто карты</div>
                    </div>
                    {btn}
                </div>

                <div className="axiom-block partner-item" style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <img src={sonatImg} alt="" style={{ width: '80px' }} />
                        <div className="card-hader-h2" style={{ margin: 0 }}>Сонат</div>
                    </div>
                    <a href="https://t.me/sonat_trade_bot" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', border: 'none' }}>
                        <button className="get-card-button" style={{ marginTop: 0, padding: '10px 20px', fontSize: '1.2em' }}>
                            Перейти
                        </button>
                    </a>
                </div>

                <div className="axiom-block partner-item" style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <img src={aurumImg} alt="" style={{ width: '80px' }} />
                        <div className="card-hader-h2" style={{ margin: 0 }}>AURUM</div>
                    </div>
                    <button
                        className="get-card-button"
                        onClick={handleAurumClick}
                        disabled={isFetchingAurum}
                        style={{ marginTop: 0, padding: '10px 20px', fontSize: '1.2em', opacity: isFetchingAurum ? 0.7 : 1, cursor: isFetchingAurum ? 'not-allowed' : 'pointer' }}
                    >
                        {isFetchingAurum ? 'Загрузка...' : 'Перейти'}
                    </button>
                </div>
                <div className="axiom-block partner-item" style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <img src={mwrImg} alt="" style={{ width: '80px' }} />
                        <div className="card-hader-h2" style={{ margin: 0 }}>MWR Live</div>
                    </div>
                    <a href="https://vip.traveladvantage.com/ambassador/checkout/vip-M?website=annadanylchuk" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', border: 'none' }}>
                        <button className="get-card-button" style={{ marginTop: 0, padding: '10px 20px', fontSize: '1.2em' }}>
                            Перейти
                        </button>
                    </a>
                </div>
            </div>
        </div>
    );
}

export { Card };